import { useTranslation } from 'react-i18next';
import { TDTypography } from '../../../../atoms/TDUILib';
import './xRayTooltip.scss';

const XRayTooltip = () => {
  const { t } = useTranslation();
  return (
    <div className='x-ray-tooltip'>
      <div>
        <TDTypography variant='body-m' fontWeight='medium'>
          {t('page_tooltip.x-ray_overview')}
        </TDTypography>
        <TDTypography variant='body-m' fontWeight='medium'>
          {t('page_tooltip.x-ray_info')}
        </TDTypography>
      </div>
    </div>
  );
};

export default XRayTooltip;
